import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { LoadIndicator } from 'devextreme-react/load-indicator'
import axios from 'axios'
import { useFavorites } from '../../hooks/useFavorites'
import FavoriteButton from '../../components/favorite-button/FavoriteButton'

interface Item {
	model: string
	text: string
	desc?: string
	hide: boolean
	filter?: string
	show_deny: boolean
	dashboard?: boolean
	folder?: string
}

interface NavigationItems {
	[key: string]: Item[]
}

export default function Search() {
	const routeParams = useParams()
	const query = routeParams['*']
	const [ajaxLoading, setAjaxLoading] = useState(true)
	const [navigationItems, setNavigationItems] = useState<NavigationItems>({})
	const { checkAllFavoritesStatus, toggleFavorite, isFavorite } = useFavorites('')

	useEffect(() => {
		document.title = 'Fiber :: Search'
	}, [])

	useEffect(() => {
		const cancelTokenSource = axios.CancelToken.source()

		if (query) {
			setAjaxLoading(true)
			setNavigationItems({})
			axios
				.get(`${API_FIBER_URL}/search?query=${query}`, { cancelToken: cancelTokenSource.token })
				.then(response => response.data)
				.then(async data => {
					if (data.models) {
						setNavigationItems(data.models)
						// Check favorites for all models across all folders
						const allModels: any[] = []
						Object.entries(data.models).forEach(([folder, items]) => {
							if (Array.isArray(items)) {
								;(items as Item[]).forEach(item => {
									allModels.push({ ...item, folder })
								})
							}
						})
						await checkAllFavoritesStatus(allModels)
					}
					setAjaxLoading(false)
				})
				.catch(error => {
					if (!axios.isCancel(error)) {
						setAjaxLoading(false)
					}
				})
		}

		return () => {
			cancelTokenSource.cancel('Request canceled')
		}
	}, [query, checkAllFavoritesStatus])

	function Buttons() {
		return (
			<>
				{Object.entries(navigationItems).map(([folder, items]) => (
					<React.Fragment key={folder}>
						<h2 className={'content-block'}>{folder}</h2>
						<div className={'content-block gridView'} style={{ marginBottom: '50px' }}>
							{items.map((item: Item) => {
								let linkTo = item.dashboard ? '/dashboard' : '/m'
								linkTo = `${linkTo}?folder=${folder}&model=${item.model}`
								if (item.filter) {
									linkTo = `${linkTo}&filter=${item.filter}`
								}
								return (
									<Link
										key={item.model}
										to={linkTo}
										className={'modelCard'}
										style={{ display: item.hide ? 'none' : 'block', position: 'relative' }}
									>
										<div className={'textWrapper'}>
											<p style={{ fontSize: '18px', marginBottom: '0' }}>{item.text}</p>
											{item.desc && <p style={{ marginTop: '2px' }}>{item.desc}</p>}
										</div>
										<FavoriteButton
											item={{ ...item, folder }}
											isFavorite={isFavorite(item.model, folder)}
											onToggle={toggleFavorite}
										/>
									</Link>
								)
							})}
						</div>
					</React.Fragment>
				))}
			</>
		)
	}

	if (ajaxLoading) {
		return (
			<h2 className={'content-block'}>
				<LoadIndicator height={20} width={20} />
			</h2>
		)
	}

	if (Object.keys(navigationItems).length === 0) {
		return null
	}

	return <Buttons />
}
